import { useQuery } from "react-query";
import { Api } from "src/apis/helpers/configs/api";
import { StandardsService } from "src/apis/services/standards/standardsService";
import { container } from "tsyringe";

export const useGetStandards = () => {
    const standardsService = container.resolve(StandardsService);
    return useQuery({
        queryKey: [Api.Standards.getStandards],
        queryFn: () => {
            return standardsService.getStandards();
        }
    })
}
